var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _tspan, _g, _g2, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormUnlinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 236,
    viewBox: "0 0 82.55 62.442",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.057 -1.68)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.893,
    y: 3.4594,
    width: 79.375,
    height: 59.267,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.34414
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.605,
    y: 9.3287,
    width: 14.552,
    height: 2.9104,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.387,
    y: 8.7827,
    width: 3.8452,
    height: 3.8452,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.355,
    y: 5.1313,
    width: 31.75,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.636,
    y: 19.559,
    width: 18.521,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#babfc3",
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 33.646164,
    y: 22.753494,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----"), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.132,
    y: 19.559,
    width: 18.521,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#babfc3",
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 58.142403,
    y: 22.753494,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.566,
    y: 15.715,
    width: 15.875,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.593,
    y: 8.9761,
    width: 21.167,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.426,
    y: 5.1314,
    width: 11.906,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("text", {
    x: 51.929695,
    y: 22.633213,
    fill: "#392781",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.6458px",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 51.929695,
    y: 22.633213,
    fill: "#cccccc",
    fontSize: "2.6458px",
    strokeWidth: 0.26458
  }, "to"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.69942 0 0 .79585 20.655 8.8272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.4425,
    y: 21.22,
    width: 107.9,
    height: 44.598,
    rx: 1.5132,
    ry: 1.3298,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.4425 29.157h107.76",
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -3.2969,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#0100ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 31.274,
    width: 19.844,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#6766ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 31.274,
    width: 21.167,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ffcb66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 31.274,
    width: 22.49,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#33f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#f33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#4c4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 48.712,
    width: 21.167,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#0200ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ffd480"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 54.525,
    width: 17.198,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#4d4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 60.338,
    width: 19.844,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 31.274,
    width: 19.981,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#8976d5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 37.087,
    width: 19.937,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#452f9d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 42.899,
    width: 16.778,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#7862d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 48.712,
    width: 21.985,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 54.525,
    width: 19.547,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#9b8adb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 60.338,
    width: 17.574,
    height: 3.9688,
    rx: 2.1793,
    ry: 1.9153,
    fill: "#7862d0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.011865 0 0 .011865 15.608 3.6752)",
    fill: "#3d4193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m878.91 798.85v199.64h-519.64v-754.55h160.24v39.516h199.15v-39.516h160.24v80.363c7.6367-0.72656 15.395-1.0898 23.152-1.0898 5.6953 0 11.395 0 16.969 0.60547v-119.88h-600v834.55h600v-239.15c-5.5742 0-11.273 0.72656-16.969 0.72656-7.7578 4e-3 -15.516-0.48438-23.152-1.2109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 402.73v-79.516h-120v119.15h120zm-40 0h-40v-39.758h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 641.03v-79.516h-120v119.15h120zm-40 0h-40v-39.637h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.06 463.33-141.46 140.36-56.484-56.121-28.363 28.121 56.605 56.121 28.242 28.121 28.363-28.121 141.46-140.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.03 800.06h-40v119.15h120v-119.15zm40 79.395h-40v-39.152h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.03 184.67c5.1367-4e-3 10.07 1.9961 13.762 5.5703 3.6875 3.5742 5.8359 8.4453 5.9961 13.578h40c-0.9375-20.773-12.559-39.582-30.723-49.707s-40.273-10.125-58.438 0c-18.16 10.125-29.785 28.934-30.719 49.707h40.242c0.125-5.1641 2.2852-10.07 6.0039-13.656 3.7227-3.5859 8.707-5.5586 13.875-5.4922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.03 362.97c-52.633 0.28906-103 21.453-140.04 58.844s-57.734 87.953-57.531 140.59c0.20312 52.633 21.285 103.04 58.613 140.14 37.332 37.105 87.859 57.879 140.49 57.762 52.633-0.11719 103.07-21.117 140.23-58.387 37.164-37.27 58.023-87.766 57.992-140.4-0.2266-52.801-21.383-103.35-58.832-140.57-37.445-37.219-88.129-58.07-140.93-57.973zm0 357.33v4e-3c-42.051-0.28906-82.266-17.246-111.83-47.148-29.562-29.906-46.055-70.312-45.863-112.36 0.19141-42.051 17.055-82.305 46.891-111.94 29.836-29.633 70.207-46.219 112.25-46.125 42.051 0.0976 82.348 16.867 112.05 46.637 29.699 29.766 46.379 70.098 46.383 112.15-0.1602 42.254-17.094 82.711-47.07 112.49-29.98 29.773-70.555 46.43-112.81 46.301z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85.214,
    y: 9.3287,
    width: 7.4083,
    height: 2.9104,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.996,
    y: 8.7827,
    width: 3.8452,
    height: 3.8452,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.74,
    y: 18.069,
    width: 11.906,
    height: 3.7042,
    rx: 0.79375,
    ry: 0.79375,
    fill: "#3d4193"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormUnlinked);
export default __webpack_public_path__ + "static/media/form-unlinked.a5c556b38cabebd321b6f449fca8d44a.svg";
export { ForwardRef as ReactComponent };